export function resolveLayoutMode(device) {
    if (device.isDesktop) {
        return "desktop";
    }
    if (device.width <= 430 || device.compactHeight) {
        return "compact";
    }
    return "comfortable";
}
